import { RewardTargetScope, StampCardSorter } from '@models/stamp';
import { atom } from 'jotai';

export const expandStoreStampIdAtom = atom<string>('');

export const stampCardSorterAtom = atom<StampCardSorter>(StampCardSorter.IssuedAtDesc);

export const historyScopeAtom = atom<{
    targetScope: RewardTargetScope,
    shopGroupId?: string,
    shopId?: string,
}>();

export const isChangingAtom = atom<boolean>(false);
